/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { CloudResourceAttachmentEventType } from '../models/CloudResourceAttachmentEventType';

export class CloudResourceAttachmentEvent {
  /**
  * Timestamp when the event occurred.
  */
  'date': Date;
  /**
  * ID of the backup policy involved in the event.
  */
  'policyId': string;
  /**
  * ID of the resource involved in the event.
  */
  'resourceId': string;
  'eventType': CloudResourceAttachmentEventType;
  /**
  * Reason for the attachment or detachment event.
  */
  'reason': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "date",
      "baseName": "date",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "policyId",
      "baseName": "policyId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "resourceId",
      "baseName": "resourceId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "eventType",
      "baseName": "eventType",
      "type": "CloudResourceAttachmentEventType",
      "format": ""
    },
    {
      "name": "reason",
      "baseName": "reason",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CloudResourceAttachmentEvent.attributeTypeMap;
  }

  public constructor() {
  }
}



